import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SidePanelPages } from 'src/_models/panels';
import { SidePanelService } from 'src/app/components/panels/side-panel/side-panel.service';
@Component({
  selector: 'app-side-panel',
  templateUrl: './side-panel.component.html',
  styleUrls: ['./side-panel.component.css']
})
export class SidePanelComponent implements OnInit, OnDestroy {

  subscriptions: Subscription[] = [];

  sidePanelPages = SidePanelPages;
  page: SidePanelPages | null = SidePanelPages.DEFAULT;

  constructor(
    private sidePanel: SidePanelService
  ) {

  }

  ngOnInit() {
    this.subscriptions = [];
    this.subPageChange()
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  subPageChange() {
    const pageOnChangeEventSub = this.sidePanel.onPageChange.subscribe({
      next: data => {
        this.page = data ?? SidePanelPages.DEFAULT;
      },
      error: err => {

      }
    });
    this.subscriptions.push(pageOnChangeEventSub);
  }
  
}
